import { JOB_PACKAGE_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IJobPackage } from "../../shared/interfaces/job-package/IJobPackage";

export const JobPackageService = {
  get: (pagination: IPagination): Promise<IBaseModel<IJobPackage[]>> =>
    requests.get(JOB_PACKAGE_URL, pagination),
  getSingle: (id: number): Promise<IJobPackage> =>
    requests.get(`${JOB_PACKAGE_URL}/${id}`),
  create: (params: Partial<IJobPackage>) => requests.post(JOB_PACKAGE_URL, params),
  update: (params: Partial<IJobPackage>, id: number) =>
    requests.put(`${JOB_PACKAGE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOB_PACKAGE_URL}/${id}`),
};
